export const findCcdaExternalSystems = (externalSystems) =>
  ((externalSystems && externalSystems.length) ? externalSystems.filter(
    (system) => {
      if (!system.activeTriggerEventTypes) {
        return false;
      }
      const eventTypes = system.activeTriggerEventTypes.filter(
        (eventType) => eventType.toLowerCase() === 'CcdaRequested'.toLowerCase());
      return eventTypes !== null && eventTypes.length > 0;
    }
  ) : null);
